export default "__VITE_ASSET__1449f18c__"